<template>
  <g>
    <path
      d="M3.01997 15.6202C2.93997 18.0402 3.33997 19.9602 3.68997 20.3102C4.03997 20.6602 5.96997 21.0702 8.37997 20.9802L3.01997 15.6202Z"
    />
    <path
      d="M13.08 3.28024C10.75 3.70024 8.28997 4.62024 6.45997 6.46024C4.62997 8.30024 3.69997 10.7502 3.27997 13.0802L10.91 20.7102C13.25 20.3002 15.7 19.3702 17.53 17.5302C19.36 15.6902 20.29 13.2402 20.71 10.9102L13.08 3.28024ZM14.8 10.6002L10.6 14.8002C10.21 15.1902 9.58997 15.1902 9.19997 14.8002C8.80997 14.4102 8.80997 13.7902 9.19997 13.4002L13.4 9.20024C13.79 8.81024 14.41 8.81024 14.8 9.20024C15.19 9.59024 15.19 10.2102 14.8 10.6002Z"
    />
    <path
      d="M20.98 8.38025C21.06 5.96025 20.66 4.04024 20.31 3.69024C19.96 3.34024 18.03 2.93024 15.62 3.02024L20.98 8.38025Z"
    />
  </g>
</template>
